import * as React from "react";
import type { SVGProps } from "react";
const SvgWeb3HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="web3_home_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M559.787 83.541a85.333 85.333 0 0 0-96.683.043L100.907 332.885A85.333 85.333 0 0 0 64 403.2v466.901a85.333 85.333 0 0 0 85.333 85.334h725.419a85.333 85.333 0 0 0 85.333-85.334V403.2a85.333 85.333 0 0 0-37.034-70.315L559.787 83.541zM511.488 153.9l363.221 249.3v466.901H149.333V403.2l362.24-249.301 24.107-35.2-24.15 35.2zM362.667 640a42.667 42.667 0 1 0 0 85.333h298.666a42.667 42.667 0 1 0 0-85.333H362.667z"
    />
  </svg>
);
export default SvgWeb3HomeIcon;
